export default __webpack_public_path__ + "static/media/indigenous2.9d2c45e8.jpg";